export default "__VITE_ASSET__qNF6VkjU__"